import { useEffect, useState } from "react";
import { supportsPopover } from "../functions/supportsPopover";

export function usePopoverSupport() {
  const [popoverSupported, setPopoverSupported] = useState<boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    setPopoverSupported(supportsPopover());
  }, []);

  return popoverSupported;
}
